import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Product from "./pages/Product";
import NFCConsulting from "./pages/NFCConsulting";
import Workshops from "./pages/Workshops";
import Contact from "./pages/Contact";
import Resources from "./pages/Resources";
import Blog from "./pages/Blog";
import Tag101 from "./pages/Tag101";
import DevelopmentKits from "./pages/DevelopmentKits";
import Android from "./pages/Android";
import JavaScriptSDK from "./pages/JavaScriptSDK";
import Windows from "./pages/Windows";
import IOS from "./pages/IOS";
import Cordova from "./pages/Cordova";
import Xamarin from "./pages/Xamarin";
import WhitePapers from "./pages/WhitePapers";
import CatchAllArticle from "./pages/CatchAllArticle";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:slug" element={<Product />} />
            <Route path="/nfc-consulting" element={<NFCConsulting />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/tag-101" element={<Tag101 />} />
            <Route path="/development-kits" element={<DevelopmentKits />} />
            <Route path="/android" element={<Android />} />
            <Route path="/javascript" element={<JavaScriptSDK />} />
            <Route path="/windows" element={<Windows />} />
            <Route path="/ios" element={<IOS />} />
            <Route path="/cordova" element={<Cordova />} />
            <Route path="/xamarin" element={<Xamarin />} />
            <Route path="/white-papers" element={<WhitePapers />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="*" element={<CatchAllArticle />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
